import { createTaxReturnRuntimeContext } from '@dec/shared';

import { type FormDefinitionResponse } from './models/definition.types';
import { type Period } from './models/types';

export const GlobalTaxReturnContext = createTaxReturnRuntimeContext<
  FormDefinitionResponse,
  Period
>();
